import React from 'react';
import { usePhoneNumbers } from '../../../hooks/usePhoneNumbers';
import { CrudStyles } from '../Crud';

const { Input, RemoveButton } = CrudStyles;

/**
 * Componente reutilizável para múltiplos telefones
 * @param {Object} props
 * @param {Array<string>} props.initialPhones - Array inicial de telefones
 * @param {Function} props.onChange - Callback quando telefones mudam (recebe array de telefones)
 * @param {Object} props.errors - Objeto com erros por índice
 * @param {boolean} props.showLabel - Se deve mostrar label (padrão: true)
 * @param {string} props.label - Texto do label (padrão: "Telefones")
 */
export default function PhoneNumbersInput({
    initialPhones = [''],
    onChange,
    errors = {},
    showLabel = true,
    label = 'Telefones',
}) {
    const {
        phoneNumbers,
        handlePhoneChange,
        addPhone,
        removePhone,
    } = usePhoneNumbers(initialPhones);

    // Ref para rastrear o último valor enviado e evitar loops
    const lastSentRef = React.useRef(phoneNumbers);
    
    // Notifica mudanças nos telefones apenas se realmente mudou
    React.useEffect(() => {
        const hasChanged = phoneNumbers.length !== lastSentRef.current.length ||
            phoneNumbers.some((phone, i) => phone !== lastSentRef.current[i]);
        
        if (hasChanged && onChange) {
            lastSentRef.current = phoneNumbers;
            onChange(phoneNumbers);
        }
    }, [phoneNumbers, onChange]);

    return (
        <>
            {showLabel && <label>{label}</label>}
            {phoneNumbers.map((phone, index) => (
                <div key={index} style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}>
                    <Input
                        placeholder="(XX) XXXXX-XXXX"
                        value={phone}
                        onChange={(e) => handlePhoneChange(index, e.target.value)}
                        $hasError={!!errors[index]}
                    />
                    {errors[index] && (
                        <span className="error">{errors[index]}</span>
                    )}
                    {index > 0 && (
                        <RemoveButton type="button" onClick={() => removePhone(index)}>
                            Remover telefone
                        </RemoveButton>
                    )}
                </div>
            ))}
            <button
                type="button"
                onClick={addPhone}
                style={{
                    marginTop: 0,
                    marginBottom: 16,
                    background: '#f0f0f0',
                    color: '#333',
                    border: '1px solid #ddd',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                }}
            >
                Adicionar outro telefone
            </button>
        </>
    );
}
